import { Pipe, PipeTransform } from '@angular/core';
import * as jalalimoment from "jalali-moment";
@Pipe({
  name: 'shamsiWithTime'
})
export class ShamsiWithTimePipe implements PipeTransform {

  transform(value: Date | string | null | undefined): string {
    if (!value) return 'نامشخص';

    const date = new Date(value);
    if (isNaN(date.getTime())) return 'تاریخ نامعتبر';

    return jalalimoment(date)
      .locale('fa')
      .format('YYYY/M/D HH:mm');
  }

}
